import { createContext, useState, useEffect } from "react";
import Cookies from "js-cookie";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Rehydrate user on initial load
  useEffect(() => {
    const token = Cookies.get("userToken");
    const storedUser = localStorage.getItem("userData");
    // console.log("Hydrating user:", storedUser, token); // 👈 add this

    if (token && storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser({ ...parsedUser, token });
    }
  }, []);

  // Function to update and persist user
  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem("userData", JSON.stringify(userData));
  };

  // Logout function
  const logoutUser = () => {
    setUser(null);
    Cookies.remove("userToken");
    localStorage.removeItem("userData");
  };

  return (
    <UserContext.Provider value={{ user, setUser: updateUser, logoutUser }}>
      {children}
    </UserContext.Provider>
  );
};
